module.exports = __webpack_public_path__ + "media/images/new-year/newyear-2-template-ru-2658cebe8cb70fa48153f279f309f8eb.png";